import { render, staticRenderFns } from "./AuditMainReferenceForm.vue?vue&type=template&id=2a7fa71f&"
import script from "./AuditMainReferenceForm.vue?vue&type=script&lang=js&"
export * from "./AuditMainReferenceForm.vue?vue&type=script&lang=js&"
import style0 from "./AuditMainReferenceForm.vue?vue&type=style&index=0&id=2a7fa71f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports